const socials = [
  { icon: 'ri-instagram-line', href: 'https://www.instagram.com/debsartdesigns', label: 'Instagram' },
  { icon: 'ri-facebook-circle-line', href: 'https://www.facebook.com/debsartdesigns', label: 'Facebook' },
  { icon: 'ri-pinterest-line', href: 'https://www.pinterest.com/Storytellerdebsartdesigns', label: 'Pinterest' },
  { icon: 'ri-youtube-line', href: 'https://www.youtube.com/@debsartdesigns', label: 'YouTube' },
  { icon: 'ri-tiktok-line', href: 'https://www.tiktok.com/@debsartdesigns', label: 'TikTok' },
];

const Footer = () => (
  <footer className="w-full bg-[#2C2420] border-t border-white/5 py-16 px-6 md:px-12 lg:px-20">
    <div className="max-w-7xl mx-auto">
      {/* Top row */}
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-12 pb-12 border-b border-white/8">
        {/* Brand — 2x logo */}
        <div className="flex flex-col gap-5 max-w-xs">
          <img
            src="https://images.squarespace-cdn.com/content/v1/6205743531e70503b4cb51e0/a95e9e87-a806-44f3-b172-8270da5024a9/logo+gold.png?format=1500w"
            alt="Deb's Art Designs"
            className="h-24 w-auto object-contain object-left"
          />
          <p className="text-white/30 text-xs leading-[1.9] tracking-wide font-light">
            Custom artwork and original creative designs — handcrafted for your space and vision.
          </p>
          <p className="text-white/20 text-[10px] tracking-wide font-light">
            5246 Buttermilk Road, Pylesville, MD 21132
          </p>
        </div>

        {/* Nav */}
        <div className="flex flex-col gap-3">
          <p className="text-white/25 text-[10px] uppercase tracking-[0.4em] mb-2 font-light">Navigate</p>
          {[
            { label: 'Gallery', id: 'services' },
            { label: 'About', id: 'about' },
            { label: 'Process', id: 'process' },
            { label: 'FAQ', id: 'faq' },
            { label: 'Contact', id: 'contact' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => document.getElementById(item.id)?.scrollIntoView({ behavior: 'smooth' })}
              className="text-white/35 text-xs uppercase tracking-[0.25em] hover:text-[#C9A96E] transition-colors cursor-pointer text-left font-light"
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* Socials */}
        <div className="flex flex-col gap-4">
          <p className="text-white/25 text-[10px] uppercase tracking-[0.4em] mb-2 font-light">Follow the Work</p>
          <div className="flex items-center gap-3">
            {socials.map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}
                className="w-9 h-9 flex items-center justify-center border border-white/10 text-white/30 hover:text-[#C9A96E] hover:border-[#C9A96E]/40 transition-all duration-300 cursor-pointer">
                <i className={`${s.icon} text-sm`}></i>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom row */}
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8">
        <p className="text-white/20 text-[10px] tracking-wide font-light">
          &copy; 2015&ndash;{new Date().getFullYear()}{' '}
          <a href="https://debsartdesigns.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors">
            DebsArtDesigns.com
          </a>{' '}
          &mdash; All Rights Reserved.
        </p>
        <a href="https://debsartdesignsphotography.squarespace.com/privacy-policy" target="_blank" rel="noopener noreferrer"
          className="text-white/20 text-[10px] tracking-wide font-light hover:text-[#C9A96E] transition-colors">
          Privacy Policy
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
